import './GrafoSearch.scss'
import {
  InputAdornment,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  TextField,
} from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import { useEffect, useState } from 'react'

import { ReactComponent as PersonaSVG } from '../../../../assets/images/icono_persona.svg'
import { ReactComponent as ProyectoSVG } from '../../../../assets/images/icono_proyecto.svg'
import { ReactComponent as EmpresaSVG } from '../../../../assets/images/icono_empresa.svg'
import { ReactComponent as SocioSVG } from '../../../../assets/images/icono_socio.svg'

export const GrafoSearch = ({
  nodes,
  handleSearchClick,
  defaultSearchTerm,
  setDefaultSearchTerm,
  setIsFocusFromClick,
}: any) => {
  const [nodesToShow, setNodesToShow] =
    useState<{ id: string; info: any; label: string; nodeType: string }[]>()
  const [searchTerm, setSearchTerm] = useState<string>(defaultSearchTerm)
  const [isListOpen, setIsListOpen] = useState<boolean>(false)

  useEffect(() => {
    setSearchTerm(defaultSearchTerm)
  }, [defaultSearchTerm])

  const handleSearchChange = (value: string) => {
    setDefaultSearchTerm(value)
    setIsListOpen(true)

    const filterNodes = nodes.filter((node: any) => {
      const label = node.label.toLowerCase()

      return label.includes(value.toLowerCase())
    })

    setNodesToShow(filterNodes)
  }

  // useEffect(() => {
  //   const handler = setTimeout(() => {
  //     if (searchTerm === '') {
  //       setNodesToShow([])
  //       return
  //     }
  //     setDefaultSearchTerm(searchTerm)
  //     setIsListOpen(true)

  //     const filterNodes = nodes.filter((node: any) => {
  //       const label = node.label.toLowerCase()
  //       return label.includes(searchTerm.toLowerCase())
  //     })
  //     setNodesToShow(filterNodes)
  //   }, 200) // espera 300ms después de dejar de escribir

  //   return () => {
  //     clearTimeout(handler) // limpiar timeout anterior en cada cambio
  //   }
  // }, [searchTerm, nodes, setDefaultSearchTerm])

  const getSVGTypeIcon = (nodeType: string): any => {
    switch (nodeType) {
      case 'persona':
        return <PersonaSVG style={{ width: '20px', height: '20px' }} />
      case 'empresa':
        return <EmpresaSVG style={{ width: '20px', height: '20px' }} />
      case 'proyecto':
        return <ProyectoSVG style={{ width: '20px', height: '20px' }} />
      case 'socio':
        return <SocioSVG style={{ width: '20px', height: '20px' }} />
    }
  }

  return (
    <div className="grafo-search_container">
      <TextField
        className="grafo-search_input"
        value={searchTerm}
        onChange={(e) => handleSearchChange(e.target.value)}
        // onChange={(e) => setSearchTerm(e.target.value)}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon></SearchIcon>
              </InputAdornment>
            ),
          },
        }}
      ></TextField>
      {searchTerm !== '' && isListOpen ? (
        <List className="grafo-search_results">
          {nodesToShow?.map((node, index) => (
            <ListItem key={index}>
              <ListItemButton
                className="grafo-search_results-itemButton"
                onClick={() => {
                  setIsListOpen(false)
                  setIsFocusFromClick(false)
                  setSearchTerm(node.label)
                  handleSearchClick(node)
                }}
              >
                <ListItemIcon className="grafo-search_results-itemIcon">
                  {getSVGTypeIcon(node.nodeType)}
                </ListItemIcon>
                <ListItemText
                  className="grafo-search_results-itemText"
                  primary={node.label}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      ) : null}
    </div>
  )
}
